import { useState} from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { ToastStyle } from "../../../../_metronic/helpers/utils";

const PendingListingModalForm = ({
  selectedListingId,
  setSelectedListingId,
  setOpenPendingListingModal,
  listing,
  getListing,
}) => {
  const [type, setType] = useState("");
  const [note, setNote] = useState('')
  const [rejectReason, setRejectReason] = useState(1)

  const cancel = () => {
    setSelectedListingId();
    setOpenPendingListingModal(false);
    setType('')
    setNote('')
    setRejectReason(1)
  };

  const PendingApproval = (type) => {
    if(type){
      axios
      .patch(
        `${process.env.REACT_APP_API_URL}/listing/${selectedListingId}?is_approved=true`
      )
      .then((res) => {
        toast("Approval Accepted", ToastStyle);
        getListing();
        if (window.gtag) {
        window.gtag('event', 'listing_approved', {
          listing_id: selectedListingId,
          listing_name: listing.title,
          owner_name: `${listing?.owner_first_name} ${listing?.owner_last_name[0]}`
      })
      }
      setSelectedListingId();
      setOpenPendingListingModal(false);
      })
      .catch((err) => {
        if(err && err.response && err.response?.data && err.response?.data?.message){
          toast(err.response.data.message, ToastStyle);
        }else{
        toast("Error Pending Approval", ToastStyle);
      }
      });
    }else{
      axios
      .patch(
        `${process.env.REACT_APP_API_URL}/listing/${selectedListingId}?is_approved=false&note=${note}&reject_reason=${rejectReason}`
      )
      .then((res) => {
        toast("Approval Rejected", ToastStyle);
        getListing();
        setSelectedListingId();
        setOpenPendingListingModal(false);
      })
      .catch((err) => {
        if(err && err.response && err.response?.data && err.response?.data?.message){
          toast(err.response.data.message, ToastStyle);
        }else{
        toast("Error Pending Approval", ToastStyle);
      }
      });
    }
  
  };

  return (
    <>
      <div className="kt_body">
        {!type ? (
          <div style={{ display: "flex", gap: "10px" }}>
           
            <button
              type="button"
              className="btn mt-4 w-100"
              onClick={() => setType("reject")}
              style={{
                background: "#ed2626",
                color: "#fff",
                height: "46px",
                fontWeight: "700",
              }}
            >
              Reject
            </button>
            <button
              type="button"
              className="btn mt-4 w-100"
              onClick={() => setType("accept")}
              style={{
                background: "#2ecc71",
                color: "#fff",
                height: "46px",
                fontWeight: "700",
              }}
            >
              Accept
            </button>
          </div>
        ) : (
          <>
            {type === "accept" ? (
              <div>
                <h4>
                  Are you sure you want to{" "}
                  <span style={{ color: "#2ecc71", fontWeight:700 }}>APPROVE</span> this listing
                </h4>
                <div className="text-center pt-5">
                <button
                    type="reset"
                    onClick={() => cancel()}
                    className="btn btn-light me-3"
                    data-kt-users-modal-action="cancel"
                  >
                    Cancel
                  </button>
                  <button
                    type="reset"
                    onClick={() => setType('')}
                    className="btn btn-dark me-3"
                    data-kt-users-modal-action="cancel"
                  >
                    Go Back
                  </button>
                  <button
                    type="submit"
                    className="btn"
                    id='approve'
                    style={{ backgroundColor: "#2ecc71", color: "#fff" }}
                    data-kt-users-modal-action="submit"
                    onClick={() => {
                      PendingApproval(true)
                    }}
                  >
                    <span className="indicator-label">APPROVE LISTING</span>
                  </button>
                </div>
              </div>
            ) : (
              <div>
                <h4>
                  Are you sure you want to{" "}
                  <span style={{ color: "#ed2626", fontWeight:700 }}>REJECT</span> this listing{" "}
                </h4>
                <div className="fv-row mb-3">
                    <label className="required fw-bold fs-6 mb-2">Select Reject Reason</label>
                    <select
                      className="form-select form-select-solid fw-bolder"
                      data-kt-select2="true"
                      data-placeholder="Select option"
                      value={rejectReason}
                      onChange={(e) => {
                        setRejectReason(e.target.value);
                      }}
                    >
                      <option value='1'>Not Suitable</option>
                      <option value='2'>Decided Against It</option>
                      <option value='3'>Not Ready - Future Potential</option>
                      <option value='4'>Unresponsive</option>
                    </select>
                  </div>
                <textarea
                  className="form-control form-control-solid w-100 mt-4"
                  placeholder="Note..."
                  value={note}
                  onChange={(e) => setNote(e.target.value)}
                />
                <div className="text-center pt-5">
                <button
                    type="reset"
                    onClick={() => cancel()}
                    className="btn btn-light me-3"
                    data-kt-users-modal-action="cancel"
                  >
                    Cancel
                  </button>
                  <button
                    type="reset"
                    onClick={() => setType('')}
                    className="btn btn-dark me-3"
                    data-kt-users-modal-action="cancel"
                
                  >
                    Go Back
                  </button>
                  <button
                    type="submit"
                    className="btn"
                    style={{ backgroundColor: "#ed2626", color: "#fff" }}
                    data-kt-users-modal-action="submit"
                    disabled={!note}
                    onClick={() => {
                      PendingApproval(false)
                    }}
                  >
                    <span className="indicator-label">REJECT LISTING</span>
                  </button>
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </>
  );
};

export { PendingListingModalForm };
